import { VenueCategoryUnionType } from '@api';
import {
  useVenueFormSchema,
  VenueFormFields,
  VenueFormValuesType,
} from '@common';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSubmitNewVenue } from './hooks';

const TRANS_KEY = 'VENUE_FORM';

type AddVenuePropsType = {
  venueCategories: VenueCategoryUnionType[];
};

export const AddVenue: React.FC<AddVenuePropsType> = ({ venueCategories }) => {
  const { t } = useTranslation('venues');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { schema, defaultValues } = useVenueFormSchema();
  const { submitNewVenue } = useSubmitNewVenue();

  const methods = useForm<VenueFormValuesType>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const onClose = () => {
    methods.reset();
    closeModal();
  };

  const handleSubmit = async (data: VenueFormValuesType) => {
    await submitNewVenue(data);
    onClose();
  };

  return (
    <>
      <Button
        size="xs"
        color="blue"
        onClick={openModal}
        aria-label={t(`${TRANS_KEY}.TITLE`)}
      >
        <FontAwesomeIcon icon={faPlus} />
      </Button>
      <Modal
        opened={opened}
        onClose={onClose}
        title={t(`${TRANS_KEY}.TITLE`)}
        size="lg"
      >
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            <VenueFormFields
              venueCategories={venueCategories}
              onClose={onClose}
            />
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};
